<template>
  <div class="Nowebcam">

    <div class="Nowebcam__title" v-html="trans('title')" />
    <div class="Nowebcam__subtitle" v-for="(list, index) in trans('list')">
      <div class="Nowebcam__prefix">{{ index + 1 }}.</div>
      <div class="Nowebcam__list" v-html="list" />
    </div>
    <div class="Btn is-border-black" @click="click">{{ trans('ok') }}</div>

    <div class="Nowebcam__lang" @click="$root.langSwitch()">
      {{ lang == 'fr' ? 'en' : 'fr' }}
    </div>

  </div>
</template>

<script>
import Frame from '@/components/frame/Frame'
export default {
  name: 'Nowebcam',
  components: { Frame },
  translations: {
    fr: {
      title: 'Activez la caméra<br> dans Safari.',
      list: [
        'Allez dans Réglages.',
        'Sélectionnez Safari.',
        'Activez Accès à la caméra et au micro.',
      ],
      ok: 'OK'
    },
    en: {
      title: 'Allow Safari access<br> to your camera.',
      list: [
        'Go to Settings.',
        'Tap Safari.',
        'Turn on Camera & Microphone Access.',
      ],
      ok: 'OK'
    }
  },
  created() {
    dataLayer.push({
      "useCaseStep": { "Id": "UCS546 - Other - Any other page | PV", "trackType": "PV" },
      "event": "VPV",
      "page": {
        ...this.tracking.page,
        contentName: "other",
        gaStep: 'nowebcam',
        requestURI: this.tracking.page.requestURI + "nowebcam",
      },
      show: this.tracking.show
    })
  },
  methods: {
    click() {
      location.reload()
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Nowebcam
  position fixed
  top 0
  left 0
  z-index 999999
  height 100%
  width 100%
  overflow hidden
  text-align center
  background white
  color #A09C94

  &__lang
    position fixed
    right 20px
    top 27px
    color black
    z-index 9999999999
    font-weight 700
    text-transform uppercase
    font-size 12px

  .Btn
    &.is-border-black
      margin-top 40px
      width 100px

  &__prefix
    width 30px
    float left

  &__list
    margin-left 30px

  &__subtitle
    margin 0 40px 20px
    line-height 26px
    text-align left
    font-size 22px
    font-weight 400

  &__title
    margin-top 70px
    color black
    font-size 22px
    position relative
    margin-bottom 50px
    line-height 26px
    font-weight 700
    clear both
    &:after
      content ' '
      position absolute
      left 50%
      transform translateX(-50%)
      height 1px
      background black
      bottom -10px
      width 85px

</style>
